import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { NotifierService, NotifierOptions } from "angular-notifier";

@Injectable({ providedIn: "root" })

export class GlobalService {
    constructor(private _datePipe: DatePipe) { }

    getfullDateTime(date: Date, time: string) {
        if (date != null) {
            return new Date(this._datePipe.transform(date, "yyyy-MM-dd") + ' ' + time);
        }
        return null;
    }

    getCurrentTime() {
        var date = new Date();

        var hh = (date.getHours() < 10 ? '0' : '') + date.getHours();
        var mm = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
        var ss = (date.getSeconds() < 10 ? '0' : '') + date.getSeconds();

        return hh + ":" + mm + ":" + ss;
    }

    getMonthList() {
        return [
            { name: 'JAN', fullName: 'January', value: '01' },
            { name: 'FEB', fullName: 'Ferruary', value: '02' },
            { name: 'MAR', fullName: 'March', value: '03' },
            { name: 'APR', fullName: 'April', value: '04' },
            { name: 'MAY', fullName: 'May', value: '05' },
            { name: 'JUN', fullName: 'June', value: '06' },
            { name: 'JUL', fullName: 'July', value: '07' },
            { name: 'AUG', fullName: 'August', value: '08' },
            { name: 'SEP', fullName: 'September', value: '09' },
            { name: 'OCT', fullName: 'October', value: '10' },
            { name: 'NOV', fullName: 'November', value: '11' },
            { name: 'DEC', fullName: 'December', value: '12' },
        ];
    }

    getYearList() {
        var dt = new Date();
        var startYear = dt.getFullYear() - 3;
        var arr = [];
        for (let index = startYear; index < dt.getFullYear() + 2; index++) {
            arr.push({ text: index.toString(), value: index, });
        }
        return arr;
    }

    convertBase64ToBlob(Base64Image: any) {
        // SPLIT INTO TWO PARTS
        const parts = Base64Image.split(';base64,');
        // HOLD THE CONTENT TYPE
        const imageType = parts[0].split(':')[1];
        // DECODE BASE64 STRING
        const decodedData = window.atob(parts[1]);
        // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
        const uInt8Array = new Uint8Array(decodedData.length);
        // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }
        // RETURN BLOB IMAGE AFTER CONVERSION
        return new Blob([uInt8Array], { type: imageType });
    }
}
